class CustomCursor extends window.MDLR.CustomElement {
  static get requiredElements() {
    return ["cursor"];
  }

  setupListeners() {
    if (window.MDLR?.CustomElement) super.setupListeners();

    // Watch for DOM events and re-run cursor setup if needed
    this.listeners.add(document, "DOMContentLoaded", () => this.#cursor(), {
      once: true,
    });
    window.addEventListener("load", () => this.#cursor(), {
      once: true,
    });
  }

  connectedCallback() {
    if (window.MDLR?.CustomElement) super.connectedCallback();
    // Run immediately on connect
    this.#cursor();
  }

  #cursor() {
    if (this._cursorInitialised) return;
    this._cursorInitialised = true;

    const cursor = this.getElement("cursor");

    function positionCursor(e) {
      const mouseX = e.clientX;
      const mouseY = e.clientY;
      cursor.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
    }

    function hideCursor() {
      cursor.style.opacity = 0;
    }

    function showCursor() {
      cursor.style.opacity = 1;
    }

    function inverseCursor() {
      cursor.classList.add("cursor--inverse");
    }

    function resetCursor() {
      cursor.classList.remove("cursor--inverse");
    }

    this.listeners.add(document.documentElement, "mousemove", positionCursor);
    this.listeners.add(document.documentElement, "mouseleave", hideCursor);
    this.listeners.add(document.documentElement, "mouseenter", showCursor);

    const handleInverseMouseOver = (event) => {
      const target = event.target.closest('[data-cursor="-inverse"]');
      if (!target) return;
      if (target.contains(event.relatedTarget)) return;
      inverseCursor();
    };

    const handleInverseMouseOut = (event) => {
      const target = event.target.closest('[data-cursor="-inverse"]');
      if (!target) return;
      if (target.contains(event.relatedTarget)) return;
      resetCursor();
    };

    this.listeners.add(document, "mouseover", handleInverseMouseOver);
    this.listeners.add(document, "mouseout", handleInverseMouseOut);
  }
}

customElements.define("custom-cursor", CustomCursor);
